module.exports = __webpack_public_path__ + "img/gift4-01-c05-k1.6c5a86f6.png";